import React from 'react';

module.exports = React.createClass({

  propTypes: {
    embed: React.PropTypes.string.isRequired,
    onBackClicked: React.PropTypes.func.isRequired,
  },

  render: function render() {
    return (
      <div className="c-player">
        <button className="c-player__button" onClick={ this.props.onBackClicked }>
          <span className="oi" data-glyph="chevron-left"></span>
        </button>
        <div style={{ width: '85%' }} dangerouslySetInnerHTML={{ __html: this.props.embed }} />
      </div>
    );
  },
});
